import React from 'react';
import { Spin } from 'antd';
import './styles.scss';

const GlobalLoading = () => {
  return (
    <div className="global-loading">
      <Spin size="large" />
    </div>
  );
};

export default GlobalLoading;
